module.exports = __webpack_public_path__ + "static/img/yy2.9b6ad11.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/rongyu/yy2.png
// module id = eAfB
// module chunks = 1